<template>
  <ModalTemplate
        :isOpen="isOpen"
        :on-close="onModalClose"
        modalMainContainerClass="squidLevelsModal"
        closeBtnClass="modal_close_btn_left"
        closeIcon="chevron-left"
        :title="$t('CATELOGUE_ITEM.ORDER_SUMMARY_MODAL.TITLE')"
    >
    <div class="orderSummaryContainer">
        <div class="">
            <div class="">
                <p class="font_regular text_black_secondary font_500">
                    {{$t("CATELOGUE_ORDER_PAYMENT.HEADER.LABEL")}}
                    {{cart.summary.order_id}}
                </p>
            </div>
        </div>

        <!-- items  -->
        <section class=" mt_12">
            <ItemCard
            v-for="(item,index) in cart.order_items"
            :item="item"
            :cart="cart"
            :isDivider="(cart.order_items.length-1) !== index"
            :isPreview="true"
            :key="index"
            />
        </section>
        <hr class="section_divider">

        <section class="">
            <h2 class="font_regular font_600 text_16">{{$t("CATELOGUE_ORDER_PAYMENT.PAYMENT.LABEL")}}</h2>
            <div class="payment_container mt-12">
            <div class="pay_item">
                <div class="font_regular font_500 text_14">{{$t("CATELOGUE_ORDER_PAYMENT.PAYMENT.TOTAL")}}</div>
                <div class="font_regular font_500 text_14">{{cart.summary.sumTotal.toFixed(2)}}</div>
            </div>
            <div class="pay_item mt_8">
                <div class="font_regular font_500 text_14">{{$t("CATELOGUE_ORDER_PAYMENT.PAYMENT.SST")}}</div>
                <div class="font_regular font_500 text_14">{{cart.summary.sst.toFixed(2)}}</div>
            </div>
            <div v-if="selectedModeItem" class="pay_item mt_8">
                <div class="font_regular font_500 text_14">
                    {{$t("CATELOGUE_ITEM.ORDER_SUMMARY_MODAL.DELIVERY_FEE")}}
                    <span class="text_black_secondary">{{selectedModeItem.title}}</span>
                </div>
                <div class="font_regular font_500 text_14">
                    {{(merchant.paid_by_customer ? selectedModeItem.amount : 0).toFixed(2)}}
                </div>
            </div>

            <div v-if="coupon.discount" class="pay_item mt_8">
                <div class="font_regular font_500 text_14 discount_label">
                    {{$t("CATELOGUE_ITEM.ORDER_SUMMARY_MODAL.DISCOUNT")}}
                    <!-- <span class="text_black_secondary">{{'Discount Mode'}}</span> -->
                </div>
                <div class="font_regular font_500 text_14 text_success">- {{coupon.discount}}</div>
            </div>

            <div class="divider mt_8 mb_8"></div>
            <!-- if marchant.paid_by_customer; then selectedModeItem.amount willbe shown as 0, but pass the real value to backend -->
            <div class="pay_item mt_8">
                <div class="font_regular font_600 text_16">{{$t("CATELOGUE_ORDER_PAYMENT.PAYMENT.TOTAL_PAY")}}</div>
                <div class="font_regular font_600 text_14 total_pay">
                    <!-- {{cart.summary.grantTotal}} -->
                    {{calculateGrantTotal.toFixed(2)}}
                </div>
            </div>
            </div>
        </section>
        <hr class="section_divider">
        <!--
        <section class="">
            <label class="input_field text_14">
                {{$t("CATELOGUE_ORDER_PAYMENT.PROMO_CODE.LABEL")}}
                <div class="font_600 mt_4">{{promo_code}}</div>
            </label>
        </section>
        <hr class="section_divider">
         -->

        <section class="coupon_check">
            <label class="input_field">
            {{$t("CATELOGUE_ORDER_PAYMENT.PROMO_CODE.LABEL")}}
            <input
                v-model="promo.promo_code"
                class="font_regular mt_4 font_500 text_14 mb_0 promo_code"
                style="border:none;"
                type="text"
                :placeholder="$t('CATELOGUE_ORDER_PAYMENT.PROMO_CODE.PLACEHOLDER')"
                @input="clearCouponCheck"
            >
            <div class="coupon_btn">
                <shop-button
                    className="mx-auto"
                    :disabled="!promo.promo_code"
                    :isLoading="uiFlags.isFetching"
                    @click="onCheckCoupon"
                >
                Check
                </shop-button>
            </div>
            <p v-if="coupon_err_message" class="error">{{coupon_err_message}}</p>
            </label>
        </section>
        <hr class="section_divider">

        <section v-if="selectedModeItem"  class="">
            <label class="input_field text_14">
                <div class="deliveryOptionLabel input_field text_14">
                    {{$t("CATELOGUE_ITEM.ORDER_SUMMARY_MODAL.DELIVERY_MODE")}}
                    <span class="text_black_secondary">
                        {{$t('CATELOGUE_ITEM.VARIANT.DELOVERY_MODE.DISTANCE')}}
                        {{selectedModeItem.distant}} Km
                    </span>
                </div>
                <div class="delivery_mode">
                    <div>
                        <h3 class="font_regular font_600 text_16 mb_0">{{selectedModeItem.title}}</h3>
                        <p class="font_regular font_500 text_14 text_black_secondary">
                            {{$t("CATELOGUE_ITEM.ORDER_SUMMARY_MODAL.ESTIMATED_TIME")}}
                            <span class="ml_8">{{selectedModeItem.time}}</span>
                        </p>
                    </div>
                    <div>{{merchant.paid_by_customer ? selectedModeItem.amount:0}}</div>
                </div>
            </label>
        </section>
        <hr v-if="selectedModeItem" class="section_divider">

        <section class="">
            <label class="input_field remark">
                {{$t("CATELOGUE_ITEM.ORDER_SUMMARY_MODAL.REMARK")}}
                <div class="mt_8 text_14">
                    <!-- remark content here -->
                    {{cart.remark}}
                </div>
            </label>
        </section>

        <div>
            <shop-button
                className="mx-auto"
                :isLoading="isLoading"
                :disabled="isLoading || isCreateBtnDisable"
                @click="onConfirm"
            >
            {{$t("CATELOGUE_ITEM.ORDER_SUMMARY_MODAL.SUBMIT_BTN")}}
            </shop-button>
        </div>


    </div>
    </ModalTemplate>
</template>

<script>
import {mapGetters} from "vuex";
import ModalTemplate from '../../../../../dashboard/components/ModalTemplate.vue';
import ItemCard from "./../cart_components/ItemCard.vue";
import ShopButton from '../../../../components/ShopButton.vue';

export default {
    components: {
        ModalTemplate,
        ItemCard,
        ShopButton,
    },
    props:{
        isOpen: {
            type: Boolean,
            default: false
        },
        onClose: {
            type: Function,
            default: () => {},
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        cart: {
            type: Object,
            default: {
                summary:{},
                order_items:[],
            },
        },
        user: {
            type: Object,
            default: {
                phone_number: '',
            },
        },
        selectedModeItem:{
            type: Object,
            default: null,
        },
        promo:{
            type: Object,
            default: ()=>{},
        },
        merchant:{
            type: Object,
            default: {},
        },
        onConfirm:{
            type: Function,
            default: ()=>{}
        }
    },
    data(){
        return {
            coupon_err_message: "",
            couponCalled: 0,
        }
    },
    computed:{
        ...mapGetters({
            uiFlags: "coupons/getUiFlags",
            coupon:"coupons/getCoupon",
        }),
        deliveryFee(){
            if (this.merchant.paid_by_customer) {
                return  0;
            }
            return this.selectedModeItem.amount;
        },
        calculateGrantTotal(){
            this.couponCalled // just to making reactivity as coupon change was not updating UI
            let total = this.cart.summary.grantTotal;

            // discount
            const discount = this.coupon?.discount || 0;
            total -= discount;

            // delivery payment logic
            if (!this.merchant.paid_by_customer) {
                return  total;
            }
            total = total + (this.selectedModeItem?.amount || 0);
            return total;
        },
        isCreateBtnDisable(){
            if (this.promo.promo_code) {
                return this.coupon?.discount ? false: true;
            }
            return false;
        },
    },
    watch: {
        coupon: {
            deep: true,
            handler(newVal) {
            console.log('Coupon changed', newVal);
            this.couponCalled +=1;
            // force recomputation if needed
            this.$forceUpdate();
            }
        }
    },
    methods:{
        onModalClose(){
            this.clearCouponCheck();
            this.onClose();
        },
        clearCouponCheck(){
            this.coupon_err_message = '';
            this.$store.dispatch("coupons/clearCoupon",{});
        },
        async onCheckCoupon(){
            // check promo code

            try {
                console.log(this.cart);
                const result= await this.$store.dispatch("coupons/getCoupon",{
                    code: this.promo.promo_code,
                    phone_number: this.user?.phone_number,
                    items: this.cart.order_items.map((item)=>{
                        return {
                            item_price: item.item_price,
                            quantity:item.orderQuantity,
                            catalog_item_id: item.varient_id,
                        }
                    })
                });
                console.log(result,"Resul",this.cart);

            } catch (error) {
                console.log(error,error.message,error.response);
                if (error.response?.data?.error) {
                    this.coupon_err_message = error.response?.data?.error;
                    this.promo.promo_code = '';
                }else{
                    this.coupon_err_message = 'No coupon found';
                    this.promo.promo_code = '';
                }
            }

        },
    },
}
</script>


<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.orderSummaryContainer{
    padding-right: 12px;
}

.payment_container{
  margin-top: 12px;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #EEEEEE;
  .pay_item{
    display: flex;
    justify-content: space-between;
  }
  div{
    .total_pay{
      color: #8D25F6;
    }
  }
}

.discount_label{
    color: #1A8000;
}

.delivery_mode{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
}
.remark{
    color: #444444;

}

.deliveryOptionLabel{
  display: flex;
  justify-content: space-between;
}

.coupon_check{
    position: relative;
    .coupon_btn{
        position: absolute;
        top: 26px;
        right: 0;
    }
}
.error{
    color: red;
}

</style>